/**
 * @description: "Application UI constructor"
 * @return: "HTML Elements"
 */

class UI {
    header: HTMLElement | null;
    headerIntersect: HTMLElement | null;
    overlay: HTMLElement | null;
    navBar: HTMLElement | null;
    navBarLists: HTMLElement | null;
    navBarList: HTMLElement[];
    navBarToggle: HTMLElement | null;
    navBarDropdown: HTMLElement[] | null;
    heroSection: HTMLElement | null;
    callToAction: HTMLElement | null;
    callToActionAnchor: HTMLElement | null
    serviceCards: HTMLElement[] | null
    form: HTMLElement | null

    constructor() {
        this.header = document.querySelector("[data-header]")
        this.headerIntersect = document.querySelector("[data-observer-intercept]")
        this.overlay = document.querySelector("[data-overlay]")
        this.navBar = document.querySelector("[data-navbar]")
        this.navBarLists = document.querySelector("[data-nav-items]")
        this.navBarList = Array.from(document.querySelectorAll('[data-nav-item]'))
        this.navBarToggle = document.querySelector("[data-toggle]")
        this.navBarDropdown = Array.from(document.querySelectorAll(".dropdown"))
        this.heroSection = document.getElementById("hero")
        this.callToAction = document.querySelector("[data-cta]")
        this.callToActionAnchor = document.querySelector("[data-cta-anchor]")
        this.serviceCards = Array.from(document.querySelectorAll("[data-presentation='card']"))
        this.form = document.querySelector(".form-module")
    }
}

export default UI
